import { AssetImage } from '@/modules/assetImage/entities/interfaces';
import { useCallback } from 'react';

interface UseAssetImageValidationProps {
  assetImage?: Partial<AssetImage>;
}

export const useAssetImageValidation = ({ assetImage }: UseAssetImageValidationProps) => {
  const isAfterNow = useCallback((value: string) => {
    if (!value) {
      return null;
    }

    const isValid = new Date(value).getTime() > new Date().getTime();

    return isValid ? null : 'Deve ser uma data futura';
  }, []);

  const isAfterInitialDate = useCallback(
    (value: string) => {
      if (!assetImage?.initialDate || !value) {
        return null;
      }

      const isValid = new Date(value).getTime() > new Date(assetImage.initialDate).getTime();

      return isValid ? null : 'Deve ser uma data depois do início de exibição';
    },
    [assetImage?.initialDate],
  );

  const isBeforeEndDate = useCallback(
    (value: string) => {
      if (!assetImage?.endDate || !value) {
        return null;
      }

      const isValid = new Date(value).getTime() < new Date(assetImage.endDate).getTime();

      return isValid ? null : 'Deve ser uma data antes do fim de exibição';
    },
    [assetImage?.endDate],
  );

  return {
    isAfterNow,
    isAfterInitialDate,
    isBeforeEndDate,
  };
};
